import { useEffect, useState } from "react";
import { Download, Share, PlusSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function InstallPWAButton({ compact = false }) {
  const [installEvent, setInstallEvent] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [showGuide, setShowGuide] = useState(false);

  useEffect(() => {
    const onPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
    };
    const onInstalled = () => {
      setInstalled(true);
      setInstallEvent(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const install = async () => {
    if (!installEvent) {
      setShowGuide(true);
      return;
    }
    await installEvent.prompt();
    const choice = await installEvent.userChoice;
    if (choice.outcome === "accepted") setInstalled(true);
    setInstallEvent(null);
  };

  return (
    <>
      <Button onClick={install}
        className={`bg-[#F2B90D] hover:bg-[#DFA90C] text-black rounded-sm font-heading uppercase text-xs h-9 ${compact ? "w-9 px-0" : ""}`}
        data-testid="install-pwa-btn">
        <Download className={`w-4 h-4 ${compact ? "" : "mr-1.5"}`} /> {compact ? <span className="sr-only">Instalar app</span> : "Instalar app"}
      </Button>

      <Dialog open={showGuide} onOpenChange={setShowGuide}>
        <DialogContent className="bg-[#171717] border-neutral-800 text-white max-w-sm rounded-xl">
          <DialogHeader>
            <DialogTitle className="font-heading uppercase">Instalar GR Soluciones</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-sm text-neutral-300">
            <p>En iPhone, Apple pide completar la instalación desde el menú de Safari:</p>
            <ol className="space-y-3">
              <li className="flex gap-3"><Share className="w-5 h-5 text-[#F2B90D] shrink-0" /><span><b className="text-white">1. Tocá Compartir</b><br />El cuadrado con la flecha hacia arriba.</span></li>
              <li className="flex gap-3"><PlusSquare className="w-5 h-5 text-[#F2B90D] shrink-0" /><span><b className="text-white">2. Agregar a inicio</b><br />Elegí “Agregar a pantalla de inicio”.</span></li>
              <li className="flex gap-3"><Download className="w-5 h-5 text-[#F2B90D] shrink-0" /><span><b className="text-white">3. Tocá Agregar</b><br />Después abrí GR Soluciones desde el nuevo ícono.</span></li>
            </ol>
            <p className="text-xs text-neutral-500">Si no aparece la opción, abrí esta página directamente con Safari.</p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
